// ───────────────────────────────────────────────────────────────────────────
// FILL THESE IN. Every legal/policy page reads from here, so you only edit once.
// Replace each [[ ... ]] placeholder with your real registered-business details.
// These appear publicly on Terms / Privacy / Refund / Shipping / Contact pages
// that Razorpay (and customers) will read, so they must be accurate.
// ───────────────────────────────────────────────────────────────────────────
export const BUSINESS = {
  brandName: "EzyDinePro",
  legalName: "CodeWiz Technologies",
  // Full registered address (Razorpay requires a real business address).
  address: "1st Floor, Sandeepini Nagar, 1-82/12, Yendada, Visakhapatnam, Andhra Pradesh 530045",
  supportEmail: "support@ezydinepro.com",
  supportPhone: "[[SUPPORT PHONE, e.g. +91 XXXXX XXXXX]]",
  gstin: "[[GSTIN — or remove this line if not registered]]",
  // Governing law / jurisdiction for disputes.
  jurisdiction: "Visakhapatnam, Andhra Pradesh, India",
  // Subscription refund window in days (used in the Refund policy text).
  refundWindowDays: "[[e.g. 7]]",
  // Support hours shown on the Contact page.
  supportHours: "[[e.g. Mon–Sat, 10:00–19:00 IST]]",
  website: "https://ezydinepro.com",
};

// Single source of truth for the "last updated" date shown on each policy page.
export const POLICY_LAST_UPDATED = "22 July 2026";
